<template>
  <div>
    <highcharts :options="highChartOptions"></highcharts>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  props: {
    selectedDateRangeID: {
      type: String,
      default: 'current-month',
    }
  },
  data() {
    return {
      jobTypes: [],
      highChartOptions: {
        credits: {
          enabled: false
        },
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: '{point.y:f}'
            }
          }
        },
        tooltip: {
          enabled: false,
        },
        series: [],
      },
    }
  },
  watch: {
    selectedDateRangeID() {
      this.get()
    }
  },
  computed: {
    ...mapGetters({
      config: 'config/config',
    })
  },
  mounted() {
    // debugger
    this.get()
  },
  methods: {
    jobTypeByID(id) {
      return this.jobTypes.filter(e => e.id === id)[0]
    },
    get() {
      (async () => {
        let dateRange = this.$getDateRangeByIdentifier(this.selectedDateRangeID)

        const jobTypes = await axios.get('job-types')
        const grouped = await axios.post('reports/job-types/grouped', {
          from: dateRange.from.format(this.config.dateTimeFormats.api),
          to: dateRange.to.format(this.config.dateTimeFormats.api),
          group: 'day',
        })

        Promise.all([jobTypes, grouped])
          .then(values => {
            let jobTypes = values[0].data
            this.jobTypes = jobTypes

            let jobTypesCount = values[1].data
            let count = []
            let labels = []
            for (let i in jobTypesCount) {
              count.push(jobTypesCount[i].count)
              labels.push(this.jobTypeByID(jobTypesCount[i].job_type_id).name)
            }

            this.highChartOptions.xAxis.categories = labels
            this.highChartOptions.series = [
              {
                name: 'Job Type',
                showInLegend: false,
                data: count,
              },
            ]
          })

      })()
    },
  }
}
</script>
